export default __webpack_public_path__ + "static/broadband-elite-facts-75754d9c83ee1abf70be7757b2e1e81b.pdf";